import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import Api from "@/_helpers/Api"
import { trans } from "@/_providers/Translation"
import { LineChart } from "@mui/x-charts"
import moment from "moment"

function IncomesByCategory() {
  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState([])
  const [historical, setHistorical] = useState([])
  const [predicted, setPredicted] = useState([])
  const [categories, setCategories] = useState([])
  const [filters, setFilters] = useState({ category_id: "" })

  useEffect(() => {
    loadData()
  }, [filters])

  function loadData() {
    setLoading(true)

    Api.get(`analytics/income-by-category?category_id=${filters.category_id}`)
      .then((res) => {
        setLabels(
          res.data.chart_data.labels?.map((date) => {
            return moment(date, "YYYY-MM").isSame(moment(), "month")
              ? trans("analytics.today")
              : moment(date, "YYYY-MM").format("MM.YYYY")
          }) || [],
        )
        setHistorical(res.data.chart_data.historical || [])
        setPredicted(res.data.chart_data.predicted || [])
        setCategories(res.data.categories || [])

        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  const historicalSeries = labels.map((_, i) =>
    i < historical.length ? (historical[i] ?? null) : null,
  )

  const boundaryIndex = historical.length - 1
  const predictedSeries = labels.map((_, i) => {
    if (i === boundaryIndex) return historical[boundaryIndex] ?? null
    if (i > boundaryIndex) return predicted[i - historical.length] ?? null
    return null
  })

  function hasAnyData() {
    return labels.length > 0
  }

  function handleFilterChange(e) {
    const { name, value } = e.target

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <div className="repair-requests-chart">
      <div className="head">
        <h3>{trans("analytics.incomesByCategory")}</h3>
        <div className="right">
          {loading ? (
            <Skeleton height={40} width={140} count={1} />
          ) : (
            <select
              value={filters.category_id || ""}
              name="category_id"
              onChange={handleFilterChange}
            >
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !hasAnyData() ? (
        <div
          className="alert info"
          style={{
            marginBottom: 0,
            width: "100%",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <LineChart
          xAxis={[{ scaleType: "point", data: labels }]}
          series={[
            {
              id: "pu-hist",
              label: trans("analytics.historicalData"),
              area: true,
              data: historicalSeries,
              color: "#35B084",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
            {
              id: "pu-pred",
              label: trans("analytics.forecast"),
              data: predictedSeries,
              color: "#35B084",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
          ]}
          height={295}
          sx={{
            "& .MuiLineElement-series-pu-pred": { strokeDasharray: "6 3" },
            "& .MuiAreaElement-series-pu-hist": {
              fill: "url(#rev-hist-gradient-2)",
            },
            "& .MuiLineElement-root": { strokeWidth: 1 },
          }}
          slotProps={{
            legend: { hidden: true },
          }}
        >
          <defs>
            <linearGradient id="rev-hist-gradient-2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#35B084" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#35B084" stopOpacity={0.02} />
            </linearGradient>
          </defs>
        </LineChart>
      )}
    </div>
  )
}

export default IncomesByCategory
